if ('querySelector' in document) {
	window.addEventListener('load', initVuaCalculator);
}

function initVuaCalculator() {
	var root = document.getElementById('vua-calculator');

	if (!root) {
		return;
	}

	var ids = {
		cropPrice: root.querySelector('#cropPrice'),
		totalAcres: root.querySelector('#totalAcres'),
		nameA: root.querySelector('#nameA'),
		yieldA: root.querySelector('#yieldA'),
		vuaA: root.querySelector('#vuaA'),
		nameB: root.querySelector('#nameB'),
		yieldB: root.querySelector('#yieldB'),
		vuaB: root.querySelector('#vuaB'),
	};

	function fmt(v, decimals, prefix) {
		decimals = decimals === undefined ? 2 : decimals;
		prefix = prefix === undefined ? '$' : prefix;

		if (isNaN(v) || v === null) {
			return '—';
		}

		var abs = Math.abs(v);
		var sign = v < 0 ? '-' : '';
		var str = abs.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

		return sign + prefix + str;
	}

	function fmtNum(v, decimals) {
		decimals = decimals === undefined ? 1 : decimals;

		if (isNaN(v) || v === null) {
			return '—';
		}

		return v.toFixed(decimals);
	}

	function fmtPct(v) {
		if (isNaN(v) || v === null || v === Infinity) {
			return '—';
		}

		return (v * 100).toFixed(1) + '%';
	}

	function diffClass(el, val) {
		el.classList.toggle('is-negative', val < 0);
	}

	function calc() {
		var price = parseFloat(ids.cropPrice.value) || 0;
		var acres = parseFloat(ids.totalAcres.value) || 0;
		var yA = parseFloat(ids.yieldA.value) || 0;
		var vuaA = parseFloat(ids.vuaA.value) || 0;
		var yB = parseFloat(ids.yieldB.value) || 0;
		var vuaB = parseFloat(ids.vuaB.value) || 0;
		var nA = ids.nameA.value || 'Variety A';
		var nB = ids.nameB.value || 'Variety B';

		var grossA = yA * price;
		var netA = grossA - vuaA;
		var grossB = yB * price;
		var netB = grossB - vuaB;

		var diff = netB - netA;
		var totalDiff = diff * acres;
		var winner = diff > 0 ? nB : (diff < 0 ? nA : 'Tied');
		var winnerPanel = diff > 0 ? 'B' : (diff < 0 ? 'A' : null);

		var yieldAdv = yB - yA;
		var yieldPct = yA > 0 ? yieldAdv / yA : 0;
		var beYield = price > 0 ? (netA + vuaB) / price : 0;

		root.querySelector('#grossA').textContent = fmt(grossA);
		root.querySelector('#netA').textContent = fmt(netA);
		root.querySelector('#grossB').textContent = fmt(grossB);
		root.querySelector('#netB').textContent = fmt(netB);

		root.querySelector('#panelA').classList.toggle('is-winner', winnerPanel === 'A');
		root.querySelector('#panelB').classList.toggle('is-winner', winnerPanel === 'B');

		root.querySelector('#advWinner').textContent = winner;
		root.querySelector('#advPerAcre').textContent = fmt(Math.abs(diff));
		root.querySelector('#advTotal').textContent = fmt(Math.abs(totalDiff), 0);
		root.querySelector('#advTotalSub').textContent = 'across ' + acres.toLocaleString() + ' acres';

		root.querySelector('#beYieldAdv').textContent = fmtNum(yieldAdv, 1);
		root.querySelector('#beYieldPct').textContent = fmtPct(yieldPct);
		root.querySelector('#beBreakeven').textContent = fmtNum(beYield, 2);

		root.querySelector('#thA').textContent = nA;
		root.querySelector('#thB').textContent = nB;

		root.querySelector('#tYieldA').textContent = fmtNum(yA, 1);
		root.querySelector('#tYieldB').textContent = fmtNum(yB, 1);

		var yd = yieldAdv;
		root.querySelector('#tYieldDiff').textContent = (yd >= 0 ? '+' : '') + fmtNum(yd, 1);
		diffClass(root.querySelector('#tYieldDiff'), yd);

		root.querySelector('#tVuaA').textContent = fmt(vuaA);
		root.querySelector('#tVuaB').textContent = fmt(vuaB);

		var vd = vuaB - vuaA;
		root.querySelector('#tVuaDiff').textContent = (vd >= 0 ? '+' : '') + fmt(vd);
		diffClass(root.querySelector('#tVuaDiff'), vd);

		root.querySelector('#tGrossA').textContent = fmt(grossA);
		root.querySelector('#tGrossB').textContent = fmt(grossB);

		var gd = grossB - grossA;
		root.querySelector('#tGrossDiff').textContent = (gd >= 0 ? '+' : '') + fmt(gd);
		diffClass(root.querySelector('#tGrossDiff'), gd);

		root.querySelector('#tNetA').textContent = fmt(netA);
		root.querySelector('#tNetB').textContent = fmt(netB);
		root.querySelector('#tNetDiff').textContent = (diff >= 0 ? '+' : '') + fmt(diff);
		diffClass(root.querySelector('#tNetDiff'), diff);
	}

	Object.keys(ids).forEach(function (key) {
		ids[key].addEventListener('input', calc);
	});

	calc();
}
